import React, { useState, useEffect } from 'react';
import { getLastMonth21st, formatDateForInput } from '../../utils/dateUtils';

const TotalOrders = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const apiUrl = import.meta.env.VITE_API_URL;
    const totalOrdersEndpoint = import.meta.env.VITE_get_total_orders;

    useEffect(() => {

        const dateDisplay = formatDateForInput(new Date())
       
        setFromDate(dateDisplay);
        setToDate(dateDisplay);
    }, []);

    const fetchOrders = async () => {
        if (!fromDate || !toDate) return;

        try {
            setLoading(true);
            const response = await fetch(`${apiUrl}${totalOrdersEndpoint}?fromDate=${fromDate}&toDate=${toDate}`);

            if (response.ok) {
                const data = await response.json();
                setOrders(data);
            } else {
                console.error('Error fetching orders');
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = () => {
        fetchOrders();
    };


    const downloadReport = () => {
        if (orders.length === 0) return;

        let csvContent = '\uFEFF'; // UTF-8 BOM for Arabic
        csvContent += 'الصنف,النوع,إجمالي العدد,إجمالي السعر\n';

        orders.forEach(menu => {
            menu.items.forEach(item => {
                csvContent += `"${item.itemName}","${item.categoryName}",${item.totalCount},${item.totalPrice}\n`;
            });
            
            // Add delivery service row
            csvContent += `"خدمه التوصيل","",0,${menu.deliveryPrice.toFixed(2)}\n`;
            
            // Add menu total row
            const menuTotalCount = menu.totalItemsCount;
            const menuTotalPrice = menu.totalItemsPrice;
            csvContent += `"الإجمالي","",${menuTotalCount},${menuTotalPrice.toFixed(2)}\n`;
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `تقرير_الطلبات_${fromDate}_${toDate}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const printReport = () => {
        const sections = document.querySelectorAll('.menu-section');
        if (!sections || sections.length === 0) return;

        // Get the single parent that contains all menus
        const container = sections[0].parentElement;
        if (!container) return;

        const printWindow = window.open('', '_blank', 'width=900,height=700');
        if (!printWindow) return;

        const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
            .map(node => node.outerHTML)
            .join('\n');

        const content = container.outerHTML;

        const html = `<!doctype html>
                        <html lang="ar" dir="rtl">
                        <head>
                            <meta charset="utf-8" />
                            <title>تقرير الطلبات</title>
                                ${styles}
                                <style>
                                    body { margin: 16px; }
                                    @page { size: A4; margin: 12mm; }
                                    .menu-section { break-inside: avoid; page-break-inside: avoid; }
                                    table { width: 100%; border-collapse: collapse; }
                                    th, td { border: 1px solid #ccc; padding: 6px 8px; }
                                    thead th { background: #f5f5f5; }
                                </style>
                            </head>
                                <body>
                                ${content}
                                <script>
                                  window.onload = function() { window.focus(); window.print(); window.close(); };
                                <\/script>
                            </body>
                        </html>`;

        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();
    };

    return (
        <section className="main_content">
            <div className="container">
                <h1 className="page-title">عرض إجمالي الطلبات</h1>

                {/* Action Icons */}
                <div>
                    <button className="action-button download" onClick={downloadReport} title="تحميل CSV">
                        <span className="download-icon">↓</span>
                    </button>
                    <button className="action-button print" onClick={printReport} title="طباعة">
                        <span className="print-icon">🖨️</span>
                    </button>
                </div>

                {/* Date Filters */}
                <div className="date-filters">
                    <div className="date-input-group">
                        <label htmlFor="fromDate">من:</label>
                        <input
                            type="date"
                            id="fromDate"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>
                    <div className="date-input-group">
                        <label htmlFor="toDate">إلى:</label>
                        <input
                            type="date"
                            id="toDate"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                    <button className="btn btn-secondary" onClick={handleSearch}>
                        بحث
                    </button>
                </div>

                {/* Orders Report */}
                {loading ? (
                    <div className="loading-message">جاري التحميل...</div>
                ) : orders.length > 0 ? (
                    <div>
                        {orders.map((menu, menuIndex) => (
                            <div key={menuIndex} className="menu-section">
                                <h2 className="section-title">{menu.menuName}</h2>

                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="item-header">الصنف</th>
                                            <th className="type-header">النوع</th>
                                            <th className="count-header">إجمالي العدد</th>
                                            <th className="price-header">إجمالي السعر</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {menu.items.map((item, itemIndex) => (
                                            <tr key={itemIndex}>
                                                <td className="item-cell">{item.itemName}</td>
                                                <td className="type-cell">{item.categoryName}</td>
                                                <td className="count-cell">{item.totalCount}</td>
                                                <td className="price-cell">{item.totalPrice.toFixed(2)}</td>
                                            </tr>
                                        ))}
                                        
                                        {/* Delivery Service Row */}
                                        <tr className="delivery-row">
                                            <td className="delivery-cell">خدمه التوصيل</td>
                                            <td className="delivery-type"></td>
                                            <td className="delivery-count"></td>
                                            <td className="delivery-price">{menu.deliveryPrice.toFixed(2)}</td>
                                        </tr>
                                        
                                        {/* Menu Total Row */}
                                        <tr className="menu-total-row">
                                            <td className="menu-total-label">الإجمالي</td>
                                            <td className="menu-total-type"></td>
                                            <td className="menu-total-count">
                                                {menu.totalItemsCount}
                                            </td>
                                            <td className="menu-total-price">
                                                {menu.totalItemsPrice.toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="no-data">لا توجد بيانات للعرض</div>
                )}
            </div>
        </section>
    );
};

export default TotalOrders;
